import React, { useState } from 'react'
import styled from 'styled-components'

const DropdownContent = styled.div`
    padding-bottom: 20px;
    font-size: 14px;
    line-height: 1.71em;
    font-weight: 400;
`

const Wrapper = styled.div`
	border-top: 1px solid #eaeaea;
	font-size: 14px;
	font-weight: 500;

	.heading {
		color: #000;
		padding: 24px 0;
	}
`

const Dropdown = () => {
    const [state, setState] = useState(false)

	return (
		<Wrapper>
			<div
                onClick={() => setState(!state)}
                className="heading"
            >Материалы</div>
            {
                state && <DropdownContent>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Facilis, laboriosam.
                </DropdownContent>
            }
		</Wrapper>
	)
}

export default Dropdown
